import React from 'react';
import PropTypes from 'prop-types';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { FDTooltip } from '@facet-wealth/design';
import { formatContentByHint } from './ScenarioSelectionDetailedSummaryHelpers';

const useStyles = buildUseStyles('ScenarioSelectionDetailedSummaryColoredValue', (theme) => ({
  nonNegative: {
    '& > *': {
      color: `${theme.palette.facet.mint100p} !important`, // Needs !important to override FD's color CSS, which currently doesn't allow us to achieve a color similar enough to this one
    },
  },
  negative: {
    '& > *': {
      color: `${theme.palette.facet.berry500} !important`, // Needs !important to override FD's color CSS, which currently doesn't allow us to achieve a color similar enough to this one
    },
  },
}));

export const ScenarioSelectionDetailedSummaryColoredValue = ({
  ValueComponent,
  valueSize,
  valueColoredBySign,
  rawValue,
  hint,
  tooltip,
}) => {
  const classes = useStyles();
  let content = <ValueComponent value={formatContentByHint(hint, rawValue)} size={valueSize} />;
  if (tooltip) {
    content = (
      <FDTooltip title={tooltip} placement="top">
        {content}
      </FDTooltip>
    );
  }
  if (!valueColoredBySign) {
    return content;
  }
  return <div className={rawValue < 0 ? classes.negative : classes.nonNegative}>{content}</div>;
};

ScenarioSelectionDetailedSummaryColoredValue.defaultProps = {
  rawValue: undefined,
  hint: undefined,
  tooltip: undefined,
};

ScenarioSelectionDetailedSummaryColoredValue.propTypes = {
  ValueComponent: PropTypes.object.isRequired,
  valueSize: PropTypes.string.isRequired,
  valueColoredBySign: PropTypes.bool.isRequired,
  rawValue: PropTypes.number,
  hint: PropTypes.string,
  tooltip: PropTypes.string,
};
